module.exports = __webpack_public_path__ + "static/media/bell_beaker_eba_england_text_01.e1bdeb4f.jpg";